import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { costos } from '../data/content';
export function CostSection() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="costo" data-id="element-31" data-mp="9d9a9ltxyq9g">
      <div className="mx-auto max-w-readable px-5 sm:px-8" data-id="element-32" data-mp="4k6c10e7ysmx">
        <p className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-[0.28em] text-flame" data-id="element-33" data-mp="3vrisfd7a321s">
          <ScaleIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" data-mp="3qsxu5jbl6sfz" />
          El otro lado de la cuenta
        </p>
        <h2 id="costo" className="mt-4 font-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-35" data-mp="3mqkyjnqk0awx">
          ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="mt-9 overflow-hidden rounded-2xl border border-ink/10 bg-white" data-id="element-36" data-mp="3cswto4z8hn11">
          <div className="grid grid-cols-[1fr_1.3fr] bg-ink/[0.04]" data-id="element-37" data-mp="1g0d1v78n544m">
            <p className="border-r border-ink/10 px-5 py-3.5 font-display text-sm font-bold uppercase tracking-wide text-ink/50" data-id="element-38" data-mp="1fzlh6rgl0qt4">
              Sin Reset Integral
            </p>
            <p className="px-5 py-3.5 font-display text-sm font-bold uppercase tracking-wide text-flame" data-id="element-39" data-mp="p6s881t8hs8d">
              El costo real
            </p>
          </div>
          <div className="divide-y divide-ink/10" data-id="element-40" data-mp="f9x7rddehhrg">
            {costos.map(row => <div key={row.sin} className="grid grid-cols-[1fr_1.3fr]" data-id="element-41" data-mp="k88hlo3p3s9o">
                <p className="border-r border-ink/10 px-5 py-4 font-display text-[15px] font-bold leading-snug text-ink" data-id="element-42" data-mp="kakzk19ge2mq">
                  {row.sin}
                </p>
                <p className="px-5 py-4 text-[15px] leading-snug text-ink/70" data-id="element-43" data-mp="1cvunx44b5b08">
                  {row.costo}
                </p>
              </div>)}
          </div>
        </div>

        <p className="mt-10 font-display text-2xl font-extrabold text-ink sm:text-3xl" data-id="element-44" data-mp="1361m2utywa96">
          El próximo domingo puede ser diferente.
        </p>
      </div>
    </section>;
}